import { ComponentProps } from "react";

export default function BrandLogo(props: Omit<ComponentProps<"img">, "src" | "alt">) {
  return (
    <div className="w-[15rem] ml-5">
      <a href="/">
        <img width={200} {...props} src={"/logo-bpi.svg"} alt="Logo BPI" />
      </a>
    </div>
  );
}
